import React, {Component} from 'react'
import {Form} from 'antd'
import Login from '../Authentication/Login'
import ParticlesBg from 'particles-bg'



class LoginPage extends Component
{
    // constructor(){
    //     super()
    // }
    
    render(){
      //  const LoginWrap = Form.create({ name: 'normal_login' })(Login);
        return (
            <>
                <Login/>
                <ParticlesBg type="cobweb" bg></ParticlesBg>
            </>
        )
    }
}

export default  LoginPage